import { DataTestId, TextKey } from '@mews-commander/enums';
import { LocalizedMinorHighlight, LocalizedSmallParagraph } from '@mews-commander/ui';
import { mewsUniversityWidgetImage as mewsUniversityImagePath } from '@mews-commander/assets';
import { MewsImage } from '@mews/business-components';
import { Button } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { openInBrowserTab } from '@mews-commander/utils';
import { Widget } from '@mews-commander/dashboard/widgets';

const imageHeight = '196px';
const MEWS_UNIVERSITY_URL = 'https://university.mews.com/';

export const MewsUniversityWidget = () => {
    const handleClick = () => openInBrowserTab(MEWS_UNIVERSITY_URL);

    return (
        <Widget titleTextKey={TextKey.DashboardWidgetMewsUniversityTitleText}>
            <MewsImage
                src={mewsUniversityImagePath}
                height={imageHeight}
                objectFit="contain"
                objectPosition="left top"
                shouldShowLoader
            />
            <LocalizedMinorHighlight textKey={TextKey.DashboardWidgetMewsUniversityHeaderText} />
            <LocalizedSmallParagraph textKey={TextKey.DashboardWidgetMewsUniversityText} />
            <div>
                <Button
                    onClick={handleClick}
                    data-test-id={DataTestId.DashboardWidgetMewsUniversityButton}
                    type="submit"
                >
                    <LocalizedText textKey={TextKey.DiscoverMore} />
                </Button>
            </div>
        </Widget>
    );
};
